import { defineComponent as _defineComponent } from 'vue'
import { onMounted, reactive, ref } from "vue";
import type { Ref } from "vue";

// Classe
import TextShowMoreLess from "@/textShowMoreLess/textShowMoreLess.js";
import { ClubAdvantage } from "../classes/ClubAdvantage";

// Components
import PopupBase from "../../common/popupBase.vue";

// Max lines

export default /*#__PURE__*/_defineComponent({
  __name: 'ClubServiceCard',
  props: {
    refName: null,
    advantage: null
  },
  setup(__props: any) {

const props = __props as {
	refName: string;
	advantage: ClubAdvantage;
}

const MAX_LINES = 5;

// Content
const content = window.content;

// Props


// Refs
const restauration = ref(null);
const animation = ref(null);
const welness = ref(null);
const InfantClub = ref(null);
const isPopUpOpen: Ref<boolean> = ref(false);

// Methods
const handleOpenPopUp = (): void => {
	isPopUpOpen.value = true;
};

const handleClosePopUp = (): void => {
	isPopUpOpen.value = false;
};

const initTextShowMoreLess = (): void => {
	if (restauration.value) {
		const restaurationTextShowMoreLess = new TextShowMoreLess(
			restauration.value,
			MAX_LINES
		);
		restaurationTextShowMoreLess.init();
	}
	if (animation.value) {
		const animationTextShowMoreLess = new TextShowMoreLess(
			animation.value,
			MAX_LINES
		);
		animationTextShowMoreLess.init();
	}
	if (welness.value) {
		const welnessTextShowMoreLess = new TextShowMoreLess(
			welness.value,
			MAX_LINES
		);
		welnessTextShowMoreLess.init();
	}
	if (InfantClub.value) {
		const InfantClubTextShowMoreLess = new TextShowMoreLess(
			InfantClub.value,
			MAX_LINES
		);
		InfantClubTextShowMoreLess.init();
	}
};

onMounted(() => {
	initTextShowMoreLess();
});

return { __sfc: true,MAX_LINES, content, props, restauration, animation, welness, InfantClub, isPopUpOpen, handleOpenPopUp, handleClosePopUp, initTextShowMoreLess, PopupBase }
}

})